// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  //baseUrl: 'http://10.172.1.162:3555'
  //baseUrl: 'http://10.172.212.234:32137'
  //baseUrl: 'https://kmdev.orangemali.com:32137'
  //baseUrl: 'http://10.172.212.70:32111'
  //baseUrl: 'https://applidistri.orangemali.com:32111'
  // baseUrl: "http://localhost:3555",
  // baseUrl: "http://10.143.156.2:30049",
  //baseUrl: 'http://10.143.0.34:30049'
  //baseUrl: 'http://10.143.0.2:30049',
  captchaKey: "6LcKzi4pAAAAAAbrr49Bg3zK6k378aw2v8bgzPcl", //<---- inital
  // captchaKey: "6Lfuo9QrAAAAACnh3fDMZVDZVe00rHcSakn7VfAe", // <---- for testing
  baseUrl: "https://distriapi.orange.cd",
};

///// FRONT //////
// http://10.143.0.2:30050/#/login
// login : adv / DistriV2020@

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

// ng build --prod
